import React from 'react';
import PropTypes from 'prop-types';

const CarSvg = ({ profile, carType, width, height, zones, selectedZone, handleSelectZone }) => {
  return (
    <div className={`car-profile car-profile-${profile} car-type-${carType}`} data-test={`carProfile-${profile}-div`}>
      <svg x="0px" y="0px" viewBox={`0 0 ${width} ${height}`} enableBackground={`new 0 0 ${width} ${height}`}>
        {zones.map((zone) => {
          let className;
          if (selectedZone === zone.id) className = 'zone selected';
          else if (zone.value) className = 'zone has-value';
          else className = 'zone';
          return (
            <path
              key={zone.id}
              data-cy={zone.id}
              data-test={`${zone.id}-path`}
              className={className}
              onClick={() => handleSelectZone(zone.id)}
              d={zone.path}
            />
          );
        })}
        ;
      </svg>
    </div>
  );
};

export default CarSvg;

CarSvg.propTypes = {
  profile: PropTypes.string.isRequired,
  carType: PropTypes.string.isRequired,
  zones: PropTypes.oneOfType([PropTypes.shape(), PropTypes.array]).isRequired,
  selectedZone: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  handleSelectZone: PropTypes.func.isRequired,
};
